import LandlordVerifiedModal from './LandlordVerifiedModal';

export default LandlordVerifiedModal;
